// 全局声明 Window 类型
declare global {
  interface Window {
    Native?: {
      JavaScriptCall?: (cmd: string, params: string, callback?: (res: any) => void) => void;
    };
    NativeCall: {
      call_back: ((res: any) => void)[];
    };
  }
}

// 全局初始化
window.NativeCall = {
  call_back: [],
};

/**
 * @description 与原生交互指令方法
 * @param {string} cmd 交互指令
 * @param {Record<string, any>} arg 参数
 * @param {(res: any) => void} requestCallback 回调方法
 * @returns void
 */
export function sendNativeCmd(
  cmd: string,
  arg: Record<string, any>,
  requestCallback?: (res: any) => void
): void {
  const params = addIndex(arg || {});
  if (!window.Native) {
    console.error("window.Native is undefined,please check native code");
    return;
  }
  if (typeof window.Native.JavaScriptCall !== 'function') {
    console.error("window.Native is not function ,please check web code");
    return;
  }
  if (!window.NativeCall) {
    console.error("window.NativeCall is undefined ,please check native code");
    return;
  }
  if (requestCallback) {
    window.NativeCall.call_back[params.index] = requestCallback;
    window.Native.JavaScriptCall(cmd, JSON.stringify(params), (res) => {
      requestCallback(res);
    });
  } else {
    window.Native.JavaScriptCall(cmd, JSON.stringify(params));
  }
}

/**
 * @description addIndex 添加原生回调所需索引index
 * @param {Record<string, any>} params
 * @returns {Record<string, any>}
 */
export function addIndex(params: Record<string, any>): Record<string, any> {
  const reqData = { ...params };
  if (!reqData.index) {
    //在考虑多并发情况下，时间戳可能会存在一样情况，通过随机数来代替时间戳
    reqData.index = 1 + randomUUID(12, 10);
  }
  return reqData;
}

/**
 * @description 获取随机UUID(后续移到其他文件)
 * @param {number} len 长度
 * @param {number} radix 随机字符集合长度
 * @returns {string} 随机UUID(随机字符串)
 */
export function randomUUID(len?: number, radix?: number): string {
  const chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  const uuid: string[] = [];
  let i: number;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r: number;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}

export {};